<!-- 学校信息库 -->
<template>
  <div class="page flex-col ">
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>
    <div class="block_red flex-col"></div>
    <!-- 学校信息库 -->
    <div v-show="mation">
      <div class="section_3 flex-col">
        <div class="main">
          <!-- <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="../assets/newImage/椭圆 2.png"
          /> -->
          <div class="group_1 flex-row">
            <div class="text_13">
              <el-row>
                <el-col>
                  <el-input
                    type="text"
                    class="el-input"
                    prefix-icon="el-icon-search"
                    v-model="keywords"
                    placeholder="搜索学院关键词"
                    style="width: 270px"
                    @keyup.enter.native="getAllKb"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
            <div class="elemsousuo flex-col" @click="search()">搜索</div>
          </div>
        </div>
        <div class="text-wrapper_59 flex-row">
          <!-- <span class="text_15">热门搜索：</span>
          <span class="text_16">东京大学</span>
          <span class="text_17">中国人多</span>
          <span class="text_18">学费半年支付</span> -->
        </div>
      </div>
      <div class="block_qie flex-row">
        <div class="main">
          <img
            class="thumbnail_010"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb59cce0e73798de2431f26b74202ba9b19d58adc145d502515db964d7c84cd77"
          />
          <span class="text_11 buts" @click="back()">返回首页</span>
          <img
            class="thumbnail_020"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9cd2a54b44174a86dfcf7cf860a411307073c6418cfbb72587ca1e4acb495fb8"
          />
          <span class="text_12 buts" @click="Information()">学校信息库</span>
          <img
            class="thumbnail_020"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng9cd2a54b44174a86dfcf7cf860a411307073c6418cfbb72587ca1e4acb495fb8"
            v-if="school_uuid != ''"
          />
          <span class="text_12" @click="details()" v-if="school_uuid != ''"
            >学校详情</span
          >
        </div>
      </div>
      <div class="main">
        <div class="main1">
          <div class="box_55 flex-row justify-end">
            <div class="block_22 flex-col">
              <span class="text_196">东北地区</span>
              <div v-if="school_count != 0" class="text-wrapper_69">
                <span class="text_197">拥有</span>
                <span class="text_198"
                  >{{ school_count["东北地区"] || 0 }}所</span
                >
                <span class="text_199">学校</span>
              </div>
              <span class="text_200">关东地区</span>
              <div class="text-wrapper_70">
                <span class="text_201">拥有</span>
                <span class="text_202"
                  >{{ school_count["关东地区"] || 0 }}所</span
                >
                <span class="text_203">学校</span>
              </div>
            </div>
            <div class="block_23 flex-col justify-between">
              <div class="box_56 flex-row justify-between">
                <div class="image-text_98 flex-row justify-between">
                  <img
                    class="thumbnail_4"
                    style="margin-top: 6px"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng348523260fc09356f04cad318f45e29b4aff6140160499a364019478f66e672b"
                  />
                  <span class="text-group_21">按地区检索学校</span>
                  <span class="text-group_211"
                    >(注，勾选要查看的地区，无需选择上级地区)</span
                  >
                </div>
              </div>
              <div class="section_2 flex-col"></div>
              <el-cascader-panel
                class="section_211"
                ref="cascader"
                v-model="schoollist"
                :options="yjlist"
                :props="props"
                :collapse-tags="true"
                clearable
                @change="lookschool()"
              ></el-cascader-panel>

              <div class="list_3 flex-row">
                <!-- <div
                  class="image-text_1 flex-row buts"
                  :style="{
                    background: item.lanhutext0 == teg_key ? background_1 : '',
                  }"
                  v-for="(item, index) in loopData0"
                  :key="index"
                  @click="teg_click(item)"
                >
                  <div
                    class="image-wrapper_2 flex-col"
                    :style="{
                      background: item.lanhutext0 == teg_key ? background_ : '',
                    }"
                  >
                    <img
                      style="width: 40px; height: 40px; margin: 0"
                      class="thumbnail_31"
                      :src="
                        item.lanhutext0 == teg_key
                          ? item.lanhuimage1
                          : item.lanhuimage0
                      "
                      alt=""
                    />
                  </div>
                  <div class="text-group_57 flex-col justify-between">
                    <span class="text_29" v-html="item.lanhutext0"></span>
                    <span class="text_30" v-html="item.lanhutext1"></span>
                  </div>
                </div> -->
              </div>
              <div class="group_4 flex-col">
                <div class="box_56 flex-row justify-between">
                  <div class="image-text_98 flex-row justify-between">
                    <img
                      class="thumbnail_4"
                      style="margin-top: 6px"
                      referrerpolicy="no-referrer"
                      :src="bgc_img !== '' ? bgc_img : moren_img"
                    />
                    <span class="text-group_2">特色</span>
                  </div>
                  <!-- <span class="text_31">{{ teg_key_rb }}</span> -->
                </div>
                <div class="section_2 flex-col"></div>
                <div class="block_15 flex-row justify-between buts">
                  <div
                    v-for="(item, index) in tegList"
                    :key="index"
                    class="image-text_79 flex-row justify-between"
                    @click="tegvalue_click(item)"
                  >
                    <span class="text-group_32">{{ item.tb_name }}</span>
                    <!-- <img
                      class="thumbnail_16"
                      style="margin-top: 7px;"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng47575599c38b73b3ad6971f36b0b7aa011fe40dbef3a4baae47ad900fec99751"
                    /> -->
                    <div class="group_34 flex-col"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="block_24 flex-row">
              <div class="box_13 flex-col"></div>
              <div class="image-text_115 flex-col justify-between">
                <img
                  class="image_26"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc41540b70f55684c8c331810c108dbb4cad203b2e0178bb82ead79831c077ee9"
                />
                <div class="text-group_58 flex-col justify-between">
                  <span class="text_204">九州/冲绳地区</span>
                  <div class="text-wrapper_71">
                    <span class="text_205">拥有</span>
                    <span class="text_206"
                      >{{ school_count["九州/冲绳地区"] || 0 }}所</span
                    >
                    <span class="text_207">学校</span>
                  </div>
                </div>
              </div>
              <span class="text_36">全部地区学校数量</span>
              <div
                class="group_47 flex-col"
                style="background: url('/static/img/xiaoribenditu.png')"
              >
                <span class="text_208">北海道</span>
                <div class="block_25 flex-row">
                  <div class="text-wrapper_72">
                    <span class="text_209">拥有</span>
                    <span class="text_210"
                      >{{ school_count["北海道"] || 0 }}所</span
                    >
                    <span class="text_211">学校</span>
                  </div>
                  <img
                    class="image_27"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng6f7e93e820daa89cefa82eb7a5ebaf6925448ca934294fa61fcf27970c66d838"
                  />
                </div>
                <div class="block_26 flex-row justify-between">
                  <div class="block_27 flex-row">
                    <div class="image-text_116 flex-row justify-between">
                      <div class="text-group_59 flex-col justify-between">
                        <span class="text_212">中部地区</span>
                        <div class="text-wrapper_73">
                          <span class="text_213">拥有</span>
                          <span class="text_214"
                            >{{ school_count["中部地区"] || 0 }}所</span
                          >
                          <span class="text_215">学校</span>
                        </div>
                      </div>
                      <img
                        class="image_28"
                        referrerpolicy="no-referrer"
                        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng07f163851906a59898c05083a61b15500390bf47edbeedf737f3a84e26de988e"
                      />
                    </div>
                    <div class="image-text_117 flex-row justify-between">
                      <img
                        class="image_29"
                        referrerpolicy="no-referrer"
                        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb717edf7dbbddaeb872302ef5ce093fa11bc54a74d6ef995ea3d7dd6e98c7cd5"
                      />
                    </div>
                  </div>
                  <div class="image-wrapper_13 flex-col justify-between">
                    <img
                      class="image_30"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngcc3d5ca330486af962c9f952a4a75d01231a95730821f76bcd7faa3267898aa3"
                    />
                    <img
                      class="image_31"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngeae72a8dd4c678807bcb99f1e05e8dd4b7dabb66d613fa0590e20f40cc1418f6"
                    />
                  </div>
                </div>
                <div class="block_28 flex-row">
                  <img
                    class="image_32"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngf5b37e147920781d648bb4e9890d8ebe3308bce4973db37769957b15f9f76aa3"
                  />
                  <div class="image-text_118 flex-row justify-between">
                    <img
                      class="image_33"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd64f45da0ef624976b44ac07a9b19b5e3823f78f9802f57d1ee612faa0283302"
                    />
                    <div class="text-group_61 flex-col justify-between">
                      <span class="text_216">大阪/近畿地区</span>
                      <div class="text-wrapper_74">
                        <span class="text_217">拥有</span>
                        <span class="text_218"
                          >{{ school_count["大阪/近畿地区"] || 0 }}所</span
                        >
                        <span class="text_219">学校</span>
                      </div>
                    </div>
                  </div>
                  <div class="image-text_119 flex-row justify-between">
                    <img
                      class="image_34"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5b1ff5a67291816d1a66730d660029aae1c7ff57073b6ca42143251f31901787"
                    />
                    <div class="text-group_62 flex-col justify-between">
                      <span class="text_220">东京地区</span>
                      <div class="text-wrapper_75">
                        <span class="text_221">拥有</span>
                        <span class="text_222"
                          >{{ school_count["东京地区"] || 0 }}所</span
                        >
                        <span class="text_223">学校</span>
                      </div>
                    </div>
                  </div>
                  <div class="image-text_120 flex-row justify-between">
                    <img
                      class="image_35"
                      referrerpolicy="no-referrer"
                      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng80dc8ded724b0a2c4a29d4f0cc0c74e6f2dba12231b483e5addaeeec1ae94dbc"
                    />
                    <span class="text-group_63">四国地区</span>
                  </div>
                </div>
              </div>
              <span class="text_57">所学校</span>
              <div class="text-wrapper_76">
                <span class="text_224">拥有</span>
                <span class="text_225"
                  >{{ school_count["四国地区"] || 0 }}所</span
                >
                <span class="text_226">学校</span>
              </div>
              <span class="text_227">中国地区</span>
              <div class="text-wrapper_77">
                <span class="text_228">拥有</span>
                <span class="text_229"
                  >{{ school_count["中国地区"] || 0 }}所</span
                >
                <span class="text_230">学校</span>
              </div>
              <span class="text_62">{{ count }}</span>
            </div>
          </div>

          <div class="box_61 flex-row">
            <div class="block_9 flex-row">
              <div class="image-text_121 flex-row justify-between">
                <img
                  class="label_2"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng29967d4c076282b434ee1de68f62985616a9e7f9e14ad32a6c9e6ca706c538e2"
                />
                <span class="text-group_25">学校列表</span>
              </div>
            </div>
            <div class="block_10 flex-col"></div>
            <span class="text_63">学校一覧</span>
          </div>

          <div
            class="box_62 flex-row"
            v-for="(item, index) in schoolLlist"
            :key="index"
          >
            <div class="image-text_122 flex-row justify-between">
              <div class="block_11 flex-col">
                <div class="flex-col" style="width: 220px; height: 150px">
                  <img
                    style="width: 228px; height: 150px"
                    :src="
                      item.tb_school_img == ''
                        ? +zanwu_img
                        : 'api' + item.tb_school_img
                    "
                    alt=""
                  />
                </div>
                <!-- <div class="image-text_123 flex-row justify-between">
                  <div class="group_24 flex-col"></div>
                  <span class="text-group_26">学校对比</span>
                </div> -->
                <div class="image-text_124 flex-row justify-between">
                  <!-- <div class="group_24 flex-col"></div> -->
                  <span
                    class="text-group_26 buts"
                    style="margin: 0 auto; color: blue"
                    @click="gocontrast(item.tb_school_uuid)"
                    >学校对比</span
                  >
                </div>
              </div>
              <div class="text-group_64 flex-col">
                <span class="text_64">{{ item.tb_school_name }}</span>
                <span class="text_65">{{ item.tb_school_name }}</span>
                <div class="text-wrapper_78 flex-row">
                  <span class="text_66">学校分类：</span>
                  <span class="text_67">{{ item.tb_class_name }}</span>
                  <span class="text_68">学校属性：</span>
                  <span class="text_69">{{ item.tb_school_sx }}</span>
                  <span class="text_68">建校时间：</span>
                  <span class="text_69">{{ item.tb_school_time }}</span>
                  <span class="text_74">学校定员：</span>
                  <span class="text_75">{{ item.tb_school_dingyuan }}人</span>
                </div>
                <div class="text-wrapper_79 flex-row">
                  <span class="text_70">所在地区：</span>
                  <span class="text_71">{{ item.tb_school_address }}</span>
                  <span class="text_72">学费：</span>
                  <span class="text_73">{{ item.tb_school_xuefei }}日元</span>
                </div>
              </div>
            </div>
            <div
              class="group_25 flex-row"
              @click="select_school(item.tb_school_uuid)"
            >
              <div class="image-text_125 flex-row justify-between">
                <span class="text-group_28 buts">查看学院</span>
                <img
                  class="thumbnail_21"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng97c249608266b644f91e15e013521a8db107e30a67a78ac90c7689ac7d563fc7"
                />
              </div>
            </div>
          </div>

          <div class="box_69 flex-row justify-between">
            <div class="box_70 flex-col justify-between">
              <div class="block_13 flex-col"></div>
              <el-pagination
                background
                layout="prev, pager, next"
                limit="10"
                :total="count"
                :prev-text="'上一页'"
                :next-text="'下一页'"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <my_article></my_article>
    <div class="group_54 flex-col">
      <my-footer class="navbarone"></my-footer>
    </div>
  </div>
</template>

<script>
import navbar from "../components/navbar/navbar.vue";
import footer from "../components/footer/footer.vue";
import article from "../components/article/article.vue";
import { GetSchoolTeg } from "../api/school";
import { GetSchoolCha } from "../api/schoolcha";
import { GeRmAddress } from "../api/index";
export default {
  components: {
    "my-navbar": navbar,
    "my-footer": footer,
    my_article: article
    // "custom-pagination": CustomPagination,
  },
  data() {
    return {
      background_: "rgba(240,172,89,1.000000)",
      background_1:
        "url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb4e914803ab6befb09029521e3d088f950981be5a3c9a4eca1fe6007f51c8575) 0px 0px no-repeat",
      teg_key: "特色", //城市、地区、特色
      teg_key_rb: "エリア",
      schoolLlist: [], //学校列表数据
      school_uuid: "", //学校视频ID
      school_de: {}, //学校详情数据
      teg_value: "",
      address_value: "",
      keywords: "", //关键词搜索框
      tegList: [],
      currentPage: 1,
      schoollist: [],
      count: 0, //总数
      limit: 10,
      dd: [],
      page: 1,
      class_id: null,
      gogo: false,
      momo: false,
      mation: true,
      props: { multiple: true, checkStrictly: true },
      tail: false,
      loopData0: [
        // {
        //   lanhuimage0: "/static/img/weidiqu.png",
        //   lanhuimage1: "/static/img/diquxz.png",
        //   lanhutext0: "地区",
        //   lanhutext1: "エリア",
        // },
        {
          lanhuimage0: "/static/img/weitese.png",
          lanhuimage1: "/static/img/tese.png",
          lanhutext0: "特色",
          lanhutext1: "特色"
        }
        // ,
        // {
        //   lanhuimage0: "/static/img/weichengshi.png",
        //   lanhuimage1: "/static/img/chengshixz.png",
        //   lanhutext0: "城市",
        //   lanhutext1: "市/区",
        // },
      ],
      constants: {},
      school_count: {},
      tb_school_uuid: "",
      bgc_img: "",
      moren_img: "/static/img/tese.png",
      zanwu_img: "/static/img/zanwu.png",
      yjlist: [],
      scroll: 0,
      lookdata: {}
    };
  },
  watch: {
    "$route.query": {
      deep: true,
      immediate: true,
      handler(toQuery) {
        if (toQuery.tb_class_id) {
          this.class_id = toQuery.tb_class_id;
          this.getschoolcha();
        }
      }
    }
  },
  created() {
    //首页视频学校ID
    if (this.$route.query.tb_school_uuid != null) {
      this.school_uuid = this.$route.query.tb_school_uuid;
      // this.getschoolde();
      this.tail = true;
      this.mation = false;
    }
    //首页地区
    if (this.$route.query.keywords != null) {
      this.keywords = this.$route.query.keywords;
    }
    if (this.$route.query.address_value) {
      this.address_value = this.$route.query.address_value;
      this.teg_key = this.$route.query.teg_key;
    }
    if (this.$route.query.characteristic) {
      this.teg_value = this.$route.query.characteristic;
      this.teg_key = this.$route.query.teg_key;
    }
    if (this.$route.params.diqu) {
      this.schoollist = this.$route.params.diqu;
      console.log(this.$route.params.diqu, "-------------------------------");
    }
    if (this.$route.query.toschool && this.$route.query.diqu) {
      this.teg_value = this.$route.query.toschool;
      // this.address_value = this.$route.query.toschool;
      this.teg_key = this.$route.query.diqu;
    }
    if (this.$route.query.address_value && this.$route.query.sub_id) {
      this.schoollist = [
        [this.$route.query.address_value, this.$route.query.sub_id]
      ];
    }
    this.toTop();
    this.getschoolteg();
    this.getschoolcha();
    this.schoolguolv();
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
  },
  mounted: function() {
    window.addEventListener("scroll", this.handleScroll);
  },
  //to：从哪个路由出去的
  //from：从哪个路由进来的
  //next：路由的控制参数，常用的有next(true)和next(false)

  beforeRouteEnter(to, from, next) {
    // 设置下一个路由的 meta
    if (from.name == "schooldetails") {
      to.meta.isBack = true;
      to.meta.keepAlive = true;
      console.log("from.name11:", from.name, to.meta.keepAlive, to.meta.isBack);
    } // 让 A 缓存，即不刷新
    else {
      to.meta.keepAlive = false;
    }
    console.log("from.name22", from.name, to.meta.keepAlive);
    next();
  },

  // beforeRouteEnter(to, from, next) {
  //   // 设置下一个路由的 meta
  //           if( to.name == 'index'){
  //               to.meta.isBack = false;
  //               to.meta.keepAlive = false;
  //               console.log("from.name11:",from.name,to.meta.keepAlive, to.meta.isBack );
  //           } // 让 A 缓存，即不刷新
  //         next();
  //         },

  // beforeRouteEnter(to, from, next) {
  //         if(from.name == "schooldetails"  ){
  //             // to.meta.isBack = true;
  //             to.meta.keepAlive = ture;
  //             console.log("from.name11:",from.name,to.meta.keepAlive);
  //         } // 当从上个页面corporateInfo返回当前页面时，不刷新当前页面
  //         else{
  //           to.meta.keepAlive = false;
  //         }
  //         console.log("from.name22",from.name, to.meta.keepAlive );
  //         next();
  // },
  // beforeRouteLeave(to, from, next) {
  //         if(to.name === "index"){
  //     to.meta.keepAlive = false;
  //     console.log("to.name22",to.name,to.meta.keepAlive)
  //   }else{
  //     to.meta.keepAlive = ture;
  //   } // 当从上个页面corporateInfo返回当前页面时，不刷新当前页面
  //         next();
  // },

  // //注意activated只能在keep-alive组件中调用
  // activated() {
  //       if(!this.$route.meta.isBack == ture){
  //             // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
  //             this.$router.go(0)  //刷新当前页面
  //             to.meta.keepAlive = false;
  //             // location.reload()
  //             console.log("from.name11",from.name, to.meta.keepAlive,to.meta.isBack );
  //       }
  //       // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
  //       this.$route.meta.isBack=false
  // },
  //第四步：当再次进入（前进或者后退）时，只触发activated（注：只有在keep-alive加载时调用）
  // activated(){
  //     if(this.scroll > 0){
  //         window.scrollTo(0, this.scroll);
  //         window.addEventListener('scroll', this.handleScroll);
  //     }
  //  	},
  //  	//第五步：deactivated 页面退出时关闭事件 防止其他页面出现问题
  // 	deactivated(){
  // 	window.removeEventListener('scroll', this.handleScroll);
  // },
  activated() {
    if (!this.$route.meta.isBack) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      //刷新当前页面
      to.meta.keepAlive = false;
      //  console.log("from.name22:",meta.keepAlive);
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
    console.log("from.name33:", this.$route.meta.isBack);
  },

  methods: {
    demo() {
      if (this.schoollist.length == 0) {
        setTimeout(() => {
          // 未选择过数据,默认展开第一行数据
          let data = this.$refs.cascader.menus;
          let child1 = data[0][3].children;
          let child2 = child1[0].children;
          let child3 = child2[0].children;
          let arr = [];

          data[0] && arr.push(data[0]);
          child1 && arr.push(child1);
          child2 && arr.push(child2);
          child3 && arr.push(child3);
          this.$refs.cascader.menus = arr;
        }, 50);
      } else {
        // console.log(
        //   "已选择过数据",
        //   this.$route.query.address_value,
        //   this.$route.query.sub_id
        // );

        setTimeout(() => {
          // 未选择过数据,默认展开第一行数据
          let data = this.$refs.cascader.menus;
          let child1 =
            data[0][this.$route.query.address_value.slice(-1)].children;
          let aaa = +this.$route.query.sub_id.slice(-1) - 1;
          let child2 =
            data[0][this.$route.query.address_value.slice(-1)].children[aaa]
              .children;

          let arr = [];
          // console.log(child2, aaa);
          data[0] && arr.push(data[0]);
          child1 && arr.push(child1);

          this.schoollist = [
            // [this.$route.query.address_value],
            [this.$route.query.sub_id]
          ];

          console.log("1", this.schoollist);

          this.$refs.cascader.menus = arr;
        }, 50);
        // this.$refs.cascader.menus = arr;
        // setTimeout(() => {
        //   // 未选择过数据,默认展开第一行数据
        //   let data = this.$refs.cascader.menus;
        //   console.log(data, "=============");
        //   let child1 = data[0][this.$route.query.address_value].children;
        //   let arr = [];
        //   data[0] && arr.push(data[0]);
        //   child1 && arr.push(child1);
        //   this.$refs.cascader.menus = arr;
        // }, 50);
      }
    },
    lookschool(val) {
      this.gogo = true;
      GetSchoolCha({
        limit: this.limit,
        page: val,
        teg_key: this.teg_key,
        addresslist: this.schoollist,
        keywords: this.keywords,
        teg_value: this.address_value,
        tb_class_id: this.class_id
      }).then(response => {
        this.schoolLlist = response.data.school_list;
        this.count = response.data.address_json.address_count;
        this.school_count = response.data.address_json;
      });
    },
    schoolguolv() {
      GeRmAddress({ is_tree: true }).then(response => {
        this.yjlist = response.data; //城市
        this.demo();
      });
    },
    // 查看学校详情
    select_school(uuid) {
      // this.$route.meta.keepAlive = true; //点击跳转b页面之前，将a页面的keepAlive设置为true
      let link = this.$router.resolve({
        path: "/schooldetails",
        query: { id: uuid }
      });
      window.open(link.href, "_blank");
      // this.$router.push({
      //   path: "/schooldetails",
      //   query: {
      //     id: uuid
      //   }
      // });
    },
    // 点击翻页触发
    handleCurrentChange(val) {
      // return console.log(val, this.momo, this.gogo, {
      //   limit: this.limit,
      //   page: val,
      //   teg_key: this.teg_key,
      //   keywords: this.keywords,
      //   teg_value: this.teg_value,
      //   address_value: this.address_value,
      //   addresslist: this.schoollist
      // });
      if (this.gogo) {
        this.lookschool(val);
        return;
      }
      if (this.momo) {
        // this.lookdata
        GetSchoolCha({
          limit: this.limit,
          page: val,
          teg_key: "特色",
          keywords: this.keywords,
          teg_value: this.lookdata.value,
          address_value: this.address_value
        }).then(response => {
          this.schoolLlist = response.data.school_list;
          this.count = response.data.address_json.address_count;
          this.school_count = response.data.address_json;
        });
        return;
      }
      GetSchoolCha({
        limit: this.limit,
        page: val,
        teg_key: this.teg_key,
        keywords: this.keywords,
        addresslist: this.schoollist,
        teg_value: this.teg_value,
        address_value: this.address_value
      }).then(response => {
        this.schoolLlist = response.data.school_list;
        this.count = response.data.address_json.address_count;
        this.school_count = response.data.address_json;
      });
    },
    //返回首页
    back() {
      this.$router.push("page/index");
    },
    //当前页面地区trap切换
    // teg_click(item) {
    //   // this.background_=item.lanhuBg1
    //   this.teg_key = item.lanhutext0;
    //   this.teg_key_rb = item.lanhutext1;
    //   this.teg_value = "";
    //   this.bgc_img = item.lanhuimage1;
    //   this.page = 1;
    //   GetSchoolCha({
    //     limit: this.limit,
    //     page: this.page,
    //     teg_key: this.teg_key,
    //     keywords: this.keywords,
    //     teg_value: this.teg_value,
    //     address_value: this.address_value
    //   }).then(response => {
    //     this.schoolLlist = response.data.school_list;
    //     this.count = response.data.address_json.address_count;
    //     this.school_count = response.data.address_json;
    //   });
    //   this.getschoolteg();
    // },
    //切换标签内容数据
    tegvalue_click(item) {
      this.address_value = "";
      this.teg_value = item.value;
      this.momo = true;
      this.lookdata = item;
      GetSchoolCha({
        limit: this.limit,
        page: this.page,
        teg_key: "特色",
        keywords: this.keywords,
        teg_value: this.teg_value,
        address_value: this.address_value
      }).then(response => {
        this.schoolLlist = response.data.school_list;
        this.count = response.data.address_json.address_count;
        this.school_count = response.data.address_json;
      });
    },
    //城市 特色 区域
    getschoolteg() {
      let teg_key = "特色"; //区域
      GetSchoolTeg({ teg_key }).then(response => {
        this.tegList = response.data;
      });
    },
    //学校列表
    getschoolcha() {
      GetSchoolCha({
        limit: this.limit,
        page: this.page,
        teg_key: this.teg_key,
        addresslist: this.schoollist,
        keywords: this.keywords,
        teg_value: this.teg_value,
        address_value: this.address_value,
        tb_class_id: this.class_id
      }).then(response => {
        this.schoolLlist = response.data.school_list;
        this.count = response.data.address_json.address_count;
        this.school_count = response.data.address_json;
      });
    },

    //搜索
    search() {
      // this.getschoolteg();
      this.page = 1;
      GetSchoolCha({
        limit: this.limit,
        page: this.page,
        teg_key: this.teg_key,
        keywords: this.keywords,
        teg_value: this.teg_value,
        address_value: this.address_value,
        tb_class_id: this.class_id
      }).then(response => {
        this.schoolLlist = response.data.school_list;
        this.count = response.data.address_json.address_count;
        this.school_count = response.data.address_json;
      });
    },
    //学校详情
    details() {
      this.mation = false;
      this.tail = true;
    },

    //触发回到顶部
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    // 学校对比跳转
    gocontrast(id) {
      this.$router.push({
        path: "/answers",
        query: {
          id
        }
      });
    },
    handleScroll() {
      this.scroll = $(window).height() + $(document).scrollTop();
    }
  }
};
</script>
<style src="../../static/css/schoolCommon.css" scoped />
<style scoped>
/* ::v-deep .el-cascader-menu__wrap {
  height: 350px;
} */
/deep/ .el-carousel__container {
  height: 450px !important;
}
/deep/ .el-cascader-menu {
  min-width: 110px;
  border-right: none;
}
/deep/ .el-cascader-menu__wrap {
  height: 100%;
  overflow-x: hidden;
}
/deep/ .el-cascader-panel.is-bordered {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/page/schoolCommon.vue